import React from 'react';
interface OperationsCardProps {
  title: string;
  description: string;
  icon?: string;
}
export const OperationsCard: React.FC<OperationsCardProps> = ({
  title,
  description,
  icon
}) => {
  return <div className="flex flex-col items-start text-left" data-id="element-141">
      {icon && <div className="mb-6" data-id="element-142">
          <img src={icon} alt={title} className="w-16 h-16 md:w-20 md:h-20" data-id="element-143" />
        </div>}
      <h3 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-144">
        {title}
      </h3>
      <p className="font-inter text-base leading-relaxed text-black" data-id="element-145">
        {description}
      </p>
    </div>;
};